import { render, staticRenderFns } from "./EnterBrand.vue?vue&type=template&id=f464ef88&"
import script from "./EnterBrand.vue?vue&type=script&lang=js&"
export * from "./EnterBrand.vue?vue&type=script&lang=js&"
import style0 from "./EnterBrand.vue?vue&type=style&index=0&id=f464ef88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports